module.exports = __webpack_public_path__ + "img/hrc-resources.84013570.webp";